import nymblLogoWhite from "@/assets/nymbl-logo-white.png";
import { Eyebrow } from "@/components/shared/Eyebrow";

/** The three "what we build" tiles from nymbl.app, re-cut for Staff's core entities. */
const TILES = [
  { n: "001", title: "Solutions", tile: "nymbl-tile-1" },
  { n: "002", title: "Pods", tile: "nymbl-tile-2" },
  { n: "003", title: "Resources", tile: "nymbl-tile-3" },
] as const;

export function AuthLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="grid min-h-screen lg:grid-cols-[1.05fr_0.95fr]">
      {/* ============ LEFT — brand panel (the nymbl.app hero) ============ */}
      <div className="nymbl-panel relative hidden flex-col justify-between overflow-hidden px-14 py-12 lg:flex">
        <div aria-hidden className="nymbl-grid absolute inset-0" />

        <div className="relative flex items-center gap-4">
          <img src={nymblLogoWhite} alt="Nymbl" className="block h-9 w-auto" />
          <span className="h-7 w-px bg-sidebar-border" />
          <span className="font-display text-lg font-medium tracking-[0.2em] text-sidebar-foreground/80 uppercase">
            Staff
          </span>
        </div>

        <div className="relative max-w-2xl">
          <Eyebrow className="mb-4 text-sidebar-primary">Resource management</Eyebrow>
          <h1 className="font-display text-4xl font-medium text-white">
            Staff every Solution with <span className="text-sidebar-primary">the right Pod.</span>
          </h1>
          <p className="mt-4 max-w-md text-base text-sidebar-foreground/80">
            Fit Scores, Pods and Assignments for every Nymbl Account, in one place.
          </p>
        </div>

        <div className="nymbl-frame relative grid grid-cols-3 gap-3 rounded-sm p-3">
          {TILES.map((t) => (
            <div
              key={t.n}
              className={`${t.tile} relative flex h-32 flex-col justify-between overflow-hidden rounded-lg p-4`}
            >
              <div aria-hidden className="nymbl-grid absolute inset-0" />
              <span className="relative self-end font-mono text-xs text-white/60">{t.n}</span>
              <span className="relative font-display text-lg font-semibold">{t.title}</span>
            </div>
          ))}
        </div>
      </div>

      {/* ============ RIGHT — form panel ============ */}
      <div className="bg-background relative flex items-center justify-center px-6 py-6 lg:px-20 lg:py-6">
        <div className="w-full max-w-[380px]">{children}</div>
      </div>
    </div>
  );
}
